import { createStore } from "vuex";
import profile from "./modules/profile";
import socialMedia from "./modules/social-media";
import experiences from "./modules/experiences";
import educations from "./modules/educations";
import skills from "./modules/skills";
import interests from "./modules/interests";
import projects from "./modules/projects";
import awards from "./modules/awards";

export default createStore({
  modules: {
    profile,
    socialMedia,
    experiences,
    educations,
    skills,
    interests,
    projects,
    awards,
  },
});
